module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-onlinesupport@2x-b48bee25881ad211d85c4812a8758acc.webp";